import { Produto } from '../../shared/entity/Produto';
import { formatarDinheiro } from '../../shared/helper';
import React, { useState, useEffect, useMemo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_PP } from '../../constants';
import Divider from '../Generic/Divider';
import Touchable from '../Generic/Touchable';

type Props = {
  produto: Produto;
  goToProduto: (id: number) => void;
  hideDivider?: boolean;
};

const ItemProduto: React.FC<Props> = (props) => {
  const { produto, goToProduto, hideDivider } = props;

  const emPromocao = useMemo(
    () => produto.tamanhos.some((tamanho) => tamanho.precoPromocional > 0),
    [produto]
  );

  if (!produto.tamanhos || produto.tamanhos.length === 0) {
    return null;
  }

  const getPrecoMinMax = () => {
    if (produto.tamanhos.length === 1) {
      if (produto.tamanhos[0].precoPromocional > 0) {
        return `R$${formatarDinheiro(produto.tamanhos[0].precoPromocional)}`;
      }
      return `R$${formatarDinheiro(produto.tamanhos[0].preco)}`;
    } else {
      let precoMin = produto.tamanhos[0].preco;
      let precoMax = 0;
      produto.tamanhos.map((tamanho) => {
        if (tamanho.precoPromocional > 0) {
          if (tamanho.precoPromocional > precoMax) {
            precoMax = tamanho.precoPromocional;
          }
          if (tamanho.precoPromocional < precoMin) {
            precoMin = tamanho.precoPromocional;
          }
          return;
        }

        if (tamanho.preco > precoMax) {
          precoMax = tamanho.preco;
        }
        if (tamanho.preco < precoMin) {
          precoMin = tamanho.preco;
        }
      });
      return `R$${formatarDinheiro(precoMin)} - R$${formatarDinheiro(precoMax)}`;
    }
  };

  return (
    <Touchable onPress={() => goToProduto(produto.id)}>
      <View style={styles.header}>
        <Text style={styles.titulo}>{produto.nome}</Text>
        <Text style={styles.preco}>{getPrecoMinMax()}</Text>
      </View>
      {(produto.descricao !== '' || emPromocao) && (
        <View
          style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Text style={styles.descricao}>{produto.descricao}</Text>
          {emPromocao && <Text style={styles.promo}>PROMOÇÃO!</Text>}
        </View>
      )}
      {!hideDivider && <Divider style={{ marginTop: 10 }} />}
    </Touchable>
  );
};

const styles = StyleSheet.create({
  header: {
    paddingTop: 10,
    backgroundColor: '#fff',
    width: '100%',
    flexDirection: 'row'
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  titulo: {
    fontSize: TXT_M,
    fontWeight: '700',
    color: colors.darkGrey,
    marginBottom: 5,
    flex: 1
  },
  descricao: {
    fontSize: TXT_P,
    flex: 1
  },
  preco: {
    fontSize: TXT_P,
    fontWeight: '700',
    color: colors.values
  },
  promo: {
    fontSize: TXT_PP,
    fontWeight: '700',
    backgroundColor: colors.red,
    color: '#fff',
    borderRadius: 5,
    padding: 2,
    paddingLeft: 4,
    paddingRight: 4
  }
});

export default ItemProduto;
